module.exports = __webpack_public_path__ + "img/img51.d96426bf.svg";